// Counts answer options for an intake form question, excluding soft-deleted
// ones (Deleted: "true"). Mirrors the active-options filter in
// OptionsModalContent.jsx so the count badge matches the modal.
const countActiveOptions = (options) => {
    if (!Array.isArray(options)) return 0;

    return options.filter((o) => (o?.Deleted || "false") !== "true").length;
};

export default countActiveOptions;
